import { HTMLAttributes, useEffect, useMemo, useState } from 'react';

import { Breadcrumbs } from '@material-tailwind/react';
import { useLocation } from 'react-router-dom';

import { TOTAL_NAV_ITEM_LIST } from '@components/header/HeaderWrapper';

import { cn } from '@utils/tailwind/cn';

interface PageTitle {
  title?: string;
}

interface BreadCrumbItem {
  title: string;
  to: string;
}

export interface PageTitleProps extends HTMLAttributes<HTMLDivElement> {
  titleHidden?: boolean;
}

export const PageTitle = ({
  className,
  title,
  titleHidden,
  ...props
}: PageTitleProps) => {
  const [breadcrumbItemList, setBreadCrumbs] = useState<BreadCrumbItem[]>([]);

  const location = useLocation();

  const NAV_ITEM_LIST = useMemo(() => {
    return Object.entries(TOTAL_NAV_ITEM_LIST)
      .map(([key, value]) => {
        return value;
      })
      .reduce((acc, cur) => {
        return acc.concat(cur);
      });
  }, []);

  useEffect(() => {
    const mataches = location.pathname.split('/');
    const result: BreadCrumbItem[] = [];

    const tmpRoot = mataches[1];

    result.push({
      title: '메인',
      to: '/' + tmpRoot,
    });

    const selectedNavItems = NAV_ITEM_LIST.find(
      (navItem) => tmpRoot + '/' + mataches[2] === navItem.link,
    );

    if (selectedNavItems !== undefined) {
      result.push({
        title: selectedNavItems.title,
        to: `/${selectedNavItems.link}`,
      });

      if (
        selectedNavItems['list'] !== undefined &&
        selectedNavItems['list'].length !== 0
      ) {
        const selectedNavItem2 = selectedNavItems['list'].find(
          (navItem) => mataches[2] === navItem.link,
        );

        if (selectedNavItem2 !== undefined) {
          result.push({
            title: selectedNavItem2.title,
            to: `/${selectedNavItems.link}/${selectedNavItem2.link}`,
          });
        }
      }
    }

    setBreadCrumbs(result);
  }, [location.pathname, NAV_ITEM_LIST]);

  return (
    <div className={cn('h-fit w-full', className)} {...props}>
      <Breadcrumbs className='bg-none'>
        {breadcrumbItemList.length != 0 &&
          breadcrumbItemList.map((breadCrumb, i) => {
            return (
              <a href={breadCrumb.to} key={`breadcrumbs-${i}`}>
                <span>{breadCrumb.title}</span>
              </a>
            );
          })}
      </Breadcrumbs>
      {!titleHidden && (
        <h1 className={'text-3xl font-bold leading-[100%] tracking-tight'}>
          {title
            ? title
            : breadcrumbItemList.length != 0 &&
              breadcrumbItemList[breadcrumbItemList.length - 1].title}
        </h1>
      )}
    </div>
  );
};
